// app/StoreProvider.js
'use client'
import { Provider }     from 'react-redux'
import { store } from '@lib/store'
import ThemeManager from '@/Components/ThemeManager/ThemeManager'
import CartPersistence from '@/CartPersistence'

export default function StoreProvider({ children }) {
    return (
        <Provider store={store}>
            <ThemeManager />
            <CartPersistence />
            {children}
        </Provider>
    )
}
